// complaintSearch.js

const normalize = (s) =>
    (s || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s/]/g, '')
        .replace(/\s+/g, ' ')

const flattenComplaints = (options) => {
    const out = []
    Object.entries(options).forEach(([category, items]) => {
        items.forEach((item) => {
            const label = item.label
            const keywords = item.keywords || []
            out.push({
                category,
                label,
                keywords,
                _labelN: normalize(label),
                _keywordsN: keywords.map(normalize),
            })
        })
    })
    return out
}

// small, fast edit-distance for “did you mean”
const levenshtein = (a, b) => {
    a = normalize(a)
    b = normalize(b)
    if (!a) return b.length
    if (!b) return a.length
    const dp = Array.from({ length: a.length + 1 }, (_, i) => i)
    for (let j = 1; j <= b.length; j++) {
        let prev = dp[0]
        dp[0] = j
        for (let i = 1; i <= a.length; i++) {
            const tmp = dp[i]
            dp[i] = Math.min(
                dp[i] + 1,
                dp[i - 1] + 1,
                prev + (a[i - 1] === b[j - 1] ? 0 : 1)
            )
            prev = tmp
        }
    }
    return dp[a.length]
}

const scoreMatch = (qN, item) => {
    if (!qN) return -Infinity
    const label = item._labelN

    if (label === qN) return 1000
    if (label.startsWith(qN)) return 800
    if (label.includes(qN)) return 650

    // keyword hits
    for (const kw of item._keywordsN) {
        if (kw === qN) return 600
        if (kw.startsWith(qN)) return 520
        if (kw.includes(qN)) return 450
    }

    // light fuzzy only for shortish queries
    if (qN.length >= 3) {
        const d = levenshtein(qN, label)
        if (d <= 2) return 300 - d * 20
    }

    return -Infinity
}

export const searchComplaints = (presentingComplaintOptions, query, limit = 12) => {
    const qN = normalize(query)
    const all = flattenComplaints(presentingComplaintOptions)

    const ranked = all
        .map((item) => ({ item, score: scoreMatch(qN, item) }))
        .filter((x) => x.score > -Infinity)
        .sort((a, b) => b.score - a.score)
        .slice(0, limit)
        .map((x) => x.item)

    let didYouMean = null
    if (qN && ranked.length === 0) {
        // suggest closest label by edit distance
        const best = all
            .map((item) => ({ item, d: levenshtein(qN, item._labelN) }))
            .sort((a, b) => a.d - b.d)[0]

        if (best && best.d <= 3) didYouMean = best.item.label
    }

    return { results: ranked, didYouMean }
}